// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"753f4de9","453":"99888648"}[chunkId] + ".chunk.js";
};